export var DURATION = "duration";
